import { formatRelativeDate } from '../../../utils/FormatDate';

const AppointmentReminderRenderer = ({ data }) => {
  return (
    <>
      <p className="bell-card__name">{data.title || '—'}</p>
      <p className="bell-card__detail">
        {data.patientName && <><strong>{data.patientName}</strong> · </>}
        {formatRelativeDate(data.startTime)}
      </p>
    </>
  );
};

export default AppointmentReminderRenderer;
